export function VNodeDfs(vnode, cb) {
  if (vnode !== null && vnode !== void 0 && vnode.$children) {
    vnode.$children.forEach(child => {
      VNodeDfs(child, cb);
    });
  }
  if (vnode) {
    cb(vnode);
  }
}
//# sourceMappingURL=utils.js.map
